<script setup lang="ts">
    // @ts-nocheck
    // nocheck pga att vi har urgamla versioner av allt och TS kaosar

    import { useValidation } from "@/components/forms/reusables/useValidation";
    import KLabel from "@/components/forms/subComponents/Label/KLabel.vue";
    import { useStore } from "@/store";
    import { computed, inject, ref, toRefs } from "vue";

    const store = useStore();

    // TODO Använd CommonProps i types i Vue3
    interface Props {
        label?: string;
        validation?: string | Array<[rule: string, ...args: never]>;
        type?: never;
        name: string;
        disabled?: boolean;
        direction?: "horizontal" | "vertical";
        defaultValue?: unknown;
    }

    const props = withDefaults(defineProps<Props>(), {
        disabled: false,
        direction: "horizontal",
    });

    const { name, disabled, type, validation } = toRefs(props);
    const modifiedDisabled = ref(disabled?.value);
    const inputRef = ref();
    const inputValue = ref();

    const configNames = inject<{
        moduleName: string;
        subModuleName: string;
    }>("configNames");

    const { modifiedValidation, expose: useValidationExpose } = useValidation({
        name: name.value,
        validation: validation?.value,
        moduleName: configNames?.moduleName,
        subModuleName: configNames?.subModuleName,
    });

    const setDisabled = ({ value }: { value: boolean }) => {
        modifiedDisabled.value = value;
    };

    const getValue = () => inputValue.value;

    defineExpose({
        setDisabled,
        getValue,
        ...useValidationExpose,
    });

    const shouldBeVisible = computed(() =>
        store.getters["config/shouldBeVisibleByName"]({
            ...(configNames ?? {}),
            name: name.value,
        })
    );
</script>
<template>
    <FormulateInput
        v-if="shouldBeVisible"
        ref="inputRef"
        v-bind="{ ...$attrs, ...$props, ...$slots }"
        v-model="inputValue"
        :name="name"
        :id="name"
        type="radio"
        :class="['k-radio', direction]"
        :disabled="modifiedDisabled"
        :validate="modifiedValidation"
    >
        <template #label>
            <KLabel v-if="label" :validation="modifiedValidation" :content="label" :input-name="name" />
        </template>
    </FormulateInput>
</template>

<style scoped lang="scss">
    @use "@/components/forms/Form/styles/FormContent";
    @import "@/style/form";
    @import "@/style/variables";

    .k-radio {
        ::v-deep .formulate-input-wrapper {
            margin-top: 0;

            .formulate-input-element {
                display: flex;
                grid-auto-columns: max-content;
                column-gap: FormContent.$k-form-column-gap !important;
                row-gap: calc($form-row-gap / 2) !important;

                .formulate-input-group-item {
                    &[data-has-value="true"] {
                        .formulate-input-element-decorator {
                            box-shadow: unset;
                            background-color: #267692;
                            display: grid;
                            place-items: center;

                            &::after {
                                content: "";
                                display: block;
                                position: absolute;
                                background-color: $color-background-light;
                                width: 0.5rem;
                                height: 0.5rem;
                                border-radius: 50%;
                            }
                        }
                    }

                    .formulate-input-element-decorator {
                        top: 0;
                    }

                    .formulate-input-label {
                        display: flex;
                        margin-bottom: 0;
                        align-items: center;
                    }
                }

                input:focus ~ .formulate-input-element-decorator {
                    border: 1px solid $color-background-light;
                    outline: $input-border-focus;
                }
            }
        }

        &.vertical {
            ::v-deep .formulate-input-wrapper {
                .formulate-input-group {
                    flex-flow: column;
                }
            }
        }

        &.horizontal {
            ::v-deep .formulate-input-wrapper {
                .formulate-input-group {
                    flex-flow: row wrap;
                }
            }
        }
    }
</style>
